import { createContext } from 'react';
import type { Session } from '@obraplan/core/application/session';
import type { ProjectId } from '@obraplan/core/domain/shared/ids';
import type { Container } from '@/app/container';

/**
 * `offline`: há token no aparelho, mas o servidor não respondeu e não há sessão guardada para
 * abrir sem ele (RN-598). O token fica: quando o sinal voltar, ele ainda vale.
 */
export type SessionStatus = 'initializing' | 'no-session' | 'ready' | 'offline' | 'error';

export interface SessionState {
  readonly status: SessionStatus;
  /**
   * Sessão do perfil ativo, já com `projectId` da obra selecionada.
   *
   * É por isso que `usePermission` acerta o escopo sem receber a obra: a sessão carrega
   * o contexto, e a verificação de permissão efetiva (RN-133) segue naturalmente.
   */
  readonly session: Session | undefined;
  readonly errorMessage: string | undefined;
  readonly activeProjectId: ProjectId | undefined;
  readonly selectProject: (projectId: ProjectId | undefined) => Promise<void>;
  /** Entra com e-mail e senha. Devolve a mensagem de falha, ou nada. */
  readonly signIn: (email: string, password: string) => Promise<string | undefined>;
  readonly clearSession: () => Promise<void>;
  readonly reload: () => Promise<void>;
}

export const ContainerContext = createContext<Container | undefined>(undefined);
export const SessionContext = createContext<SessionState | undefined>(undefined);
